
import React, { Component } from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from 'redux';
import {connect} from 'react-redux';
import * as loginActions from '../../actions/loginActions';
import * as submissionActions from '../../actions/submissionActions';
import {
    Grid,
    Row,
    Col,
    FormGroup,
    FormControl,
    ControlLabel,
    Image
} from "react-bootstrap";
//import "react-select/dist/react-select.css";
import Card from "../../components/Card/Card.jsx";
import SweetAlert from 'react-bootstrap-sweetalert';
import Button from "../../components/CustomButton/CustomButton.jsx";
import rest from "../../API/api";
import ReactDOM from "react-dom";
import Datetime from "./DisplayConsentFormWizard/Personal_Step3";
import sha1 from "sha1";

class DisplaySubmissionForm extends Component {
    constructor(props) {
        super(props);
        this._readSubmission = this._readSubmission.bind(this);
        this._updateSubmission = this._updateSubmission.bind(this);
        this.state = {
            _id: "",
            TenantId: "",
            ConsentId: "",
            ConsentFormName: "",
            Artist:"",
            Date:"",
            ConsentClauses: [],
            ConsentName: "",
            ConsentAddress: "",
            ConsentPhone: "",
            ConsentEmail: "",
            ConsentNationality: "",
            ConsentGender: "",
            ConsentDOB: "",
            ConsentAge: "",
            ConsentPhotoId: "",
            ConsentPhotoIdPublicId: "",
            ConsentSignature: "",
            ConsentSignaturePublicId: "",
            ConsentGuardianName: "",
            ConsentGuardianRelation: "",
            ConsentGuardianSignature: "",
            ConsentGuardianSignaturePublicId: "",
            ConsentNotes: "",
            ConsentFooter: "",
            submitButton: false,
            ConsentNotesError: null,
        };
        this._readSubmission(this.props.userLoggedIn[0],this.props.id);

    }
    static get contextTypes() {
        return {
            router: PropTypes.object
        };
    }

    //this.setState({submitButton: false});

_readSubmission(tenant,id) {
    let tempURL = rest.submission + '/' + id;
    fetch(tempURL, {
        method: 'GET',
        headers: new Headers({
            'Content-Type': 'application/json;charset=UTF-8',
            'x-api-key': tenant.apiKey
        })
    })
        .then(response => response.json())
        .then(data => {
            //debugger;
            this.setState({
                _id: data._id,
                TenantId: data.TenantId,
                ConsentId: data.ConsentId,
                ConsentFormName: data.ConsentFormName,
                Artist: data.Artist,
                Date: data.Date,
                ConsentClauses: data.ConsentClauses,
                ConsentName: data.ConsentName,
                ConsentAddress: data.ConsentAddress,
                ConsentPhone: data.ConsentPhone,
                ConsentEmail: data.ConsentEmail,
                ConsentNationality: data.ConsentNationality,
                ConsentGender: data.ConsentGender,
                ConsentDOB: data.ConsentDOB,
                ConsentAge: data.ConsentAge,
                ConsentPhotoId: data.ConsentPhotoId,
                ConsentPhotoIdPublicId: data.ConsentPhotoIdPublicId,
                ConsentSignature: data.ConsentSignature,
                ConsentSignaturePublicId: data.ConsentSignaturePublicId,
                ConsentGuardianName: data.ConsentGuardianName,
                ConsentGuardianRelation: data.ConsentGuardianRelation,
                ConsentGuardianSignature: data.ConsentGuardianSignature,
                ConsentGuardianSignaturePublicId: data.ConsentSignaturePublicId,
                ConsentNotes: data.ConsentNotes,
                ConsentFooter: data.consentFooter
            });
            return (data);
        })
        .catch(error => console.error(error));
}

    successAlert(saved){
        if(saved) {
                this.setState({
                    alert: (
                        <SweetAlert
                            success
                            title="Your Consent Submission was updated successfully!"
                            style={{display: "block"}}
                            onConfirm={() => this.context.router.history.push("/Submissions")}
                            onCancel={() => this.context.router.history.push("/Submissions")}
                            confirmBtnBsStyle="info"
                        >
                        </SweetAlert>
                    )
                });
            }

        else
        {
            this.setState({
                alert: (
                    <SweetAlert
                        danger
                        style={{display: "block"}}
                        title="Missing required fields, please correct field values and try again!"
                        onConfirm={() => this.setState({alert: null})}
                        onCancel={() => this.setState({alert: null})}
                        confirmBtnBsStyle="danger"
                    >
                    </SweetAlert>
                )
            });
        }
    }

    _grabUserInput() {
        //debugger;
        return {
            _id: this.state._id,
            TenantId: this.state.TenantId,
            ConsentId: this.state.ConsentId,
            ConsentFormName: this.state.ConsentFormName,
            Artist: this.state.Artist,
            Date: this.state.Date,
            ConsentClauses: this.state.ConsentClauses,
            ConsentName: this.state.ConsentName,
            ConsentAddress: this.state.ConsentAddress,
            ConsentPhone: this.state.ConsentPhone,
            ConsentEmail: this.state.ConsentEmail,
            ConsentNationality: this.state.ConsentNationality,
            ConsentGender: this.state.ConsentGender,
            ConsentDOB: this.state.ConsentDOB,
            ConsentAge: this.state.ConsentAge,
            ConsentPhotoId: this.state.ConsentPhotoId,
            ConsentPhotoIdPublicId: this.state.ConsentPhotoIdPublicId,
            ConsentSignature: this.state.ConsentSignature,
            ConsentSignaturePublicId: this.state.ConsentSignaturePublicId,
            ConsentGuardianName: this.state.ConsentGuardianName,
            ConsentGuardianRelation: this.state.ConsentGuardianRelation,
            ConsentGuardianSignature: this.state.ConsentGuardianSignature,
            ConsentGuardianSignaturePublicId: this.state.ConsentSignaturePublicId,
            ConsentNotes: document.getElementById('consentNotes').value,
            ConsentFooter: this.state.consentFooter
        };

    }

    isValidated() {
        //debugger;

        var notes;
        (this.state.ConsentNotes === "")
            ? this.setState({
                consentNotesError: (
                    <small className="text-danger">
                        Please complete the notes section with important Health Dept. Information.
                    </small>
                )
            })
            : this.setState({consentNotesError: null});
        notes = (this.state.ConsentNotes !== "");

        return notes;
    }

    _updateSubmission(event) {
        event.preventDefault();

        let userInput = this._grabUserInput();
        if (this.isValidated()) {
            this.setState({submitButton: false});


        let tempURL = rest.submissions + "/" + userInput._id;
        //Using POST with the ID of the submission to update.  PUT is already used to send query string for filtering
        //Display consents.
        fetch(tempURL, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json;charset=UTF-8',
                'x-api-key': this.props.userLoggedIn[0].apiKey
            }),
            body: JSON.stringify({

                TenantId: userInput.TenantId,
                ConsentId: userInput.ConsentId,
                Date: userInput.Date,
                Artist: userInput.Artist,
                ConsentName: userInput.ConsentName,
                ConsentAddress: userInput.ConsentAddress,
                ConsentPhone: userInput.ConsentPhone,
                ConsentEmail: userInput.ConsentEmail,
                ConsentNationality: userInput.ConsentNationality,
                ConsentGender: userInput.ConsentGender,
                ConsentDOB: userInput.ConsentDOB,
                ConsentAge: userInput.consentAge,
                ConsentPhotoId: userInput.ConsentPhotoId,
                ConsentPhotoIdPublicId: userInput.ConsentPhotoIdPublicId,
                ConsentSignature: userInput.ConsentSignature,
                ConsentSignaturePublicId: userInput.ConsentSignaturePublicId,
                ConsentGuardianName: userInput.ConsentGuardianName,
                ConsentGuardianRelation: userInput.ConsentGuardianRelation,
                ConsentGuardianSignature: userInput.ConsentGuardianSignature,
                ConsentGuardianSignaturePublicId: userInput.ConsentGuardianSignaturePublicId,
                ConsentClauses: userInput.ConsentClauses,
                ConsentNotes: userInput.ConsentNotes,
                ConsentFooter: userInput.ConsentFooter,
                ConsentFormName: userInput.ConsentFormName

            }),
        })
            .then(response => response.json())
            .then(data => {
            })
            .catch(error => console.error(error));
        this.successAlert(true);
        this.setState({submitButton: true});
        } else
            this.successAlert(false);
    }

    render() {
        //debugger;
        this.clauses =  [];
        //Lets build the code to show the clauses that were saved in the form
        this.state.ConsentClauses.map((e, key) => {
                this.clauses.push(
                    <tr key={key}>
                        <td>
                            { e.Acknowledged ? "Yes"  : "No" }
                            { e.Required === "Required" ? <span className="text-danger">*</span> : <div></div> }
                        </td>
                        <td>{e.Clause}</td>
                    </tr>
                );
            })

        if (this.props.userLoggedIn[0].status) {
            return (
                <div className="main-content" style={{ backgroundImage: "url(" + require("../../assets/img/matrix.jpg") + ")" }}>
                    <Grid fluid>
                        <Card
                            content={
                                <div>
                                    <legend>Date and Artist Information</legend>
                                    { /*
                                    <Row>
                                        <Col md={5} mdOffset={1}>
                                            <FormGroup>
                                                <img
                                                    className="img-responsive"
                                                    src={this.props.consentSubmission.TitleImage}
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row> */ }
                                    <Row>
                                        <Col md={5} mdOffset={1}>
                                            <FormGroup>
                                                <ControlLabel>Consent was submitted on: </ControlLabel>
                                                <FormControl
                                                    id="TodayDate"
                                                    type="text"
                                                    name="today_date"
                                                    disabled={true}
                                                    value={this.state.Date}
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={5} mdOffset={1}>
                                            <FormGroup>
                                                <ControlLabel>The artist was: <span className="text-danger">*</span> </ControlLabel>
                                                <FormControl
                                                    id="Artist"
                                                    type="text"
                                                    name="artist"
                                                    disabled={true}
                                                    value={this.state.Artist}
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </div>
                            }
                        />
                        <Row>
                            <Col md={12}>
                                <Card
                                    title="Consent Clauses"
                                    category="The following clauses were read and either acknowledged or not, a red * indicates acknowledgement was required."
                                    content={
                                        <table className="table">
                                            <tbody>{this.clauses}</tbody>

                                        </table>
                                    }
                                />
                                <Card
                                    content={
                                        <table className="table">
                                            <tbody><h5>
                                                If any consent clause, section, subsection, provision or phrase of this
                                                release
                                                is found to be unenforceable or invalid, that portion shall be severed
                                                from this contract.
                                                The remainder of this contract will then be construed as though the
                                                unenforceable portion
                                                had never been contained in this document.
                                            </h5></tbody>
                                        </table>
                                    }
                                />


                            </Col>
                        </Row>
                        <Card
                            content={
                                <div>
                                    <legend>Personal Information Gathered <span
                                        className="text-danger">*</span></legend>
                                    <Row>
                                        <Col md={10} mdOffset={1}>
                                            <FormGroup>
                                                <ControlLabel><div>
                                                    <h5>
                                                        I hereby declare that I am of legal age (with valid proof of age) and I am
                                                        competent to sign this Agreement or, if not, that my parent or legal guardian
                                                        shall sign on my behalf, and that my parent or legal guardian is in complete
                                                        understanding and concurrence with this agreement.
                                                    </h5>
                                                </div>
                                                </ControlLabel>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        {this.state.ConsentName !== "" ?
                                            <Col md={5} mdOffset={2}>
                                                <FormGroup>
                                                    <ControlLabel>Consent's Name <span className="text-danger">*</span></ControlLabel>
                                                    <FormControl
                                                        id="consentName"
                                                        type="text"
                                                        name="name"
                                                        placeholder="Your full name"
                                                        disabled={true}
                                                        value={this.state.ConsentName}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            : <div></div>}
                                    </Row>
                                    <Row>
                                        <Col md={5} mdOffset={2}>
                                            <FormGroup>
                                                <ControlLabel>Consent's Date of Birth <span className="text-danger">*</span> </ControlLabel>
                                                <FormControl
                                                    id="ConsentDOB"
                                                    type="text"
                                                    name="dob"
                                                    disabled={true}
                                                    value={this.state.ConsentDOB}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={3}>
                                            <FormGroup>
                                                <ControlLabel>Consent's Age <span className="text-danger">*</span> </ControlLabel>
                                                <FormControl
                                                    id="ConsentAge"
                                                    type="text"
                                                    name="age"
                                                    disabled={true}
                                                    value={this.state.ConsentAge}
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    {this.state.ConsentAddress !== ""?
                                        <Row>
                                            <Col md={5} mdOffset={2}>
                                                <FormGroup>
                                                    <ControlLabel>Consent's Address <span className="text-danger">*</span></ControlLabel>
                                                    <FormControl
                                                        id="consentAddress"
                                                        type="text"
                                                        name="name"
                                                        disabled={true}
                                                        value={this.state.ConsentAddress}
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        : <div></div>}
                                    {this.state.ConsentPhone !== "" ?
                                        <Row>
                                            <Col md={5} mdOffset={2}>
                                                <FormGroup>
                                                    <ControlLabel>Consent's Phone <span className="text-danger">*</span></ControlLabel>
                                                    <FormControl
                                                        id="consentPhone"
                                                        type="phone"
                                                        name="phone"
                                                        disabled={true}
                                                        value={this.state.ConsentPhone}
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        : <div></div>}
                                    {this.state.ConsentEmail !== "" ?
                                        <Row>
                                            <Col md={5} mdOffset={2}>
                                                <FormGroup>
                                                    <ControlLabel>Consent's Email <span className="text-danger">*</span></ControlLabel>
                                                    <FormControl
                                                        id="consentEmail"
                                                        type="email"
                                                        name="email"
                                                        disabled={true}
                                                        value={this.state.ConsentEmail}
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        : <div></div>}
                                    {this.state.ConsentNationality !== "" ?
                                        <Row>
                                            <Col md={5} mdOffset={2}>
                                                <FormGroup>
                                                    <ControlLabel>Consent's Nationality <span className="text-danger">*</span></ControlLabel>
                                                    <FormControl
                                                        id="consentNationality"
                                                        type="text"
                                                        name="consent_nationality"
                                                        disabled={true}
                                                        value={this.state.ConsentNationality}
                                                    />
                                                    {this.state.consentNationalityError}
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        : <div></div>}
                                    {this.state.ConsentGender !== "" ?
                                        <Row>
                                            <Col md={5} mdOffset={2}>
                                                <FormGroup>
                                                    <ControlLabel>Consent's Gender <span className="text-danger">*</span></ControlLabel>
                                                    <FormControl
                                                        id="consentGender"
                                                        type="text"
                                                        name="gender"
                                                        disabled={true}
                                                        value={this.state.ConsentGender}
                                                    />
                                                    {this.state.consentGenderError}
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        : <div></div>}
                                    { this.state.ConsentSignature !== "" ?
                                        <Row>
                                            <Col md={5} mdOffset={2}>
                                                <FormGroup>
                                                    <ControlLabel><div>
                                                        <h5>Consent's Signature</h5>
                                                    </div>
                                                    </ControlLabel>

                                                        <div style={style.container}>
                                                            <img
                                                                style={style.captureImage}
                                                                src={this.state.ConsentSignature}
                                                            />
                                                        </div>

                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        : <div></div> }
                                    <Row>
                                        <Col md={7} mdOffset={1} >
                                            <FormGroup controlId="formControlsTextarea">
                                                <ControlLabel>Additional Health Department Notes </ControlLabel>
                                                <FormControl
                                                    id="consentNotes"
                                                    rows="5"
                                                    name="consent_Notes"
                                                    componentClass="textarea"
                                                    placeholder="Any misc or additional notes..."
                                                    bsClass="form-control"
                                                    value={this.state.ConsentNotes}
                                                    onChange={event => this.setState({ConsentNotes: event.target.value})}
                                                />
                                                {this.state.ConsentNotesError}
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </div>
                            }
                        />
                        { this.state.ConsentGuardianName !==  "" ?
                            <Card
                                content={
                                    <div>
                                        <legend>Parent /  Guardian Information <span
                                            className="text-danger">*</span></legend>
                                        { this.state.ConsentGuardianName !==  ""  ?
                                            <Row>
                                                <Col md={5} mdOffset={2}>
                                                    <FormGroup>
                                                        <ControlLabel>Consent's Guardian Name <span className="text-danger">*</span></ControlLabel>
                                                        <FormControl
                                                            id="consentGuardianName"
                                                            type="text"
                                                            name="consent_guardian"
                                                            disabled={true}
                                                            value={this.state.ConsentGuardianName}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            : <div></div> }
                                        { this.state.ConsentGuardianRelation !==  "" ?
                                            <Row>
                                                <Col md={5} mdOffset={2}>
                                                    <FormGroup>
                                                        <ControlLabel>Consent's Relation to Parent / Guardian <span className="text-danger">*</span></ControlLabel>
                                                        <FormControl
                                                            id="consentGuardianRelation"
                                                            type="text"
                                                            name="consent_relation"
                                                            disabled={true}
                                                            value={this.state.ConsentGuardianRelation}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            : <div></div> }
                                        {this.state.ConsentGuardianSignature !==  "" ?
                                            <Row>
                                                <Col md={5} mdOffset={2}>
                                                <FormGroup>
                                                    <ControlLabel>
                                                        <div><h5>Consent's Guardian / Parent Signature</h5></div>
                                                    </ControlLabel>
                                                        <div style={style.container}>
                                                            <img
                                                                style={style.captureImage}
                                                                src={this.state.ConsentGuardianSignature}
                                                            />
                                                        </div>
                                                </FormGroup>
                                                </Col>
                                            </Row>
                                            : <div></div>}
                                    </div>
                                }
                            />
                            : <div></div> }
                        { this.state.ConsentPhotoId !== "" ?
                        <Card
                            content={
                                <div>
                                    <legend>Consent's Government Issued Photo ID: <span
                                        className="text-danger">*</span></legend>
                                    <Row>
                                        <Col md={5} mdOffset={2}>
                                            <FormGroup>
                                                <ControlLabel><div>
                                                    <h5>Consent's Photo ID</h5>
                                                </div>
                                                </ControlLabel>

                                                    <div style={style.container}>
                                                        <img
                                                            style={style.captureImage}
                                                            src={this.state.ConsentPhotoId}
                                                        />
                                                    </div>

                                            </FormGroup>
                                        </Col>
                                    </Row>

                                </div>
                            }
                        />
                            : <div></div> }
                            <Card
                                content={
                                    <div>
                                        <legend>Update Submission</legend>
                                        <Row>
                                            <Col md={10} mdOffset={1}>
                                                <FormGroup>
                                                    <ControlLabel>
                                                        <div>
                                                            <h5>
                                                                {this.state.ConsentFooter}
                                                            </h5>
                                                        </div>
                                                    </ControlLabel>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={1} mdOffset={1} xs={5} xsOffset={1}>
                                                <Button
                                                    id="submit"
                                                    disabled={this.state.submitButton}
                                                    bsStyle="info"
                                                    fill
                                                    wd
                                                    pullRight
                                                    onClick={this._updateSubmission}
                                                >
                                                    Update
                                                </Button>
                                            </Col>
                                            <Col md={1} mdOffset={1} xs={5} xsOffset={1}>
                                                <Button bsStyle="info" pullRight fill wd onClick={ async () => {
                                                    let tURL = "/submissions";
                                                    await this.context.router.history.push(tURL);
                                                }}>
                                                    Cancel
                                                </Button>

                                            </Col>
                                        </Row>
                                    </div>
                                }
                                />
                        {this.state.alert}
                    </Grid>
                </div>
            );
        }
        else {
            this.context.router.history.push("/pages/login-page");
            return(null);
        }
    }
}


DisplaySubmissionForm.propTypes = {
    loginActions: PropTypes.object.isRequired,
    userLoggedIn: PropTypes.array.isRequired,
    submission: PropTypes.object.isRequired
};

function mapStateToProps(state, ownProps) {
    const id = ownProps.match.params.id;  //from editsubmission/:id
    return {
        userLoggedIn: state.userLoggedIn,
        submission: state.submission,
        id: id
    };
}

function mapDispatchToProps(dispatch) {
    return {
        loginActions: bindActionCreators(loginActions, dispatch),
        submissionActions: bindActionCreators(submissionActions, dispatch)
    };
}

const style = {
    preview: {
        position: 'relative',
    },
    captureContainer: {
        display: 'flex',
        position: 'absolute',
        justifyContent: 'center',
        zIndex: 1,
        bottom: 0,
        width: '50%'
    },
    captureButton: {
        backgroundColor: '#fff',
        borderRadius: '50%',
        height: 56,
        width: 56,
        color: '#000',
        margin: 20
    },
    captureImage: {
        width: '50%',
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(DisplaySubmissionForm);




// WEBPACK FOOTER //
// ./src/views/Forms/DisplaySubmission.jsx